import React from 'react';
import { Button } from 'reactstrap';

function ApplyRoleButton({ roleId, isRegistrationOpen, isRoleCapped, isDisabled = true, submissionStatus, onApply = () => null, showConfirmModal = () => null, className = '' }) {
  const handleClick = () => {
    if (!roleId) return;
    showConfirmModal();
  };

  return (
    <Button
      color="primary"
      onClick={handleClick}
      disabled={!roleId || isDisabled}
      data-id={roleId}
      className={`btn-cta fw-semibold px-4 text-uppercase ${className}`}
    >
      {`${submissionStatus === 'submitting' ? 'Submitting...' : ((!isRegistrationOpen || isRoleCapped) ? 'Join Waitlist' : 'Apply For This Role')}`}
    </Button>
  );
}

export default ApplyRoleButton;

